import { render, staticRenderFns } from "./payment_result.vue?vue&type=template&id=e42087bc&scoped=true"
import script from "./payment_result.vue?vue&type=script&lang=js"
export * from "./payment_result.vue?vue&type=script&lang=js"
import style0 from "./payment_result.vue?vue&type=style&index=0&id=e42087bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42087bc",
  null
  
)

export default component.exports